export const emailLayoutTypes = [
	{value: 0, label: "Básico", image: 'basic_layout.png', subject2: false, text2: false},
	{value: 1, label: "Operaciones", image: 'operations_layout.png', subject2: false, text2: false},
	{value: 2, label: "Operaciones 2 textos", image: 'operations2_layout.png', subject2: true, text2: true},
]
